import React, { forwardRef } from "react";
import { Input } from "@headlessui/react";

import { I18nKeyType } from "@/i18n";
import { useTranslate } from "@/i18n/useTranslate";
import { useTranslator } from "@/i18n/useTranslator";
import { classNames } from "@/src/utils/classNames";

import { DsText } from ".";

export type DsInputPropsType = React.InputHTMLAttributes<HTMLInputElement> & {
  title?: I18nKeyType;
  placeholder?: I18nKeyType;
  error?: boolean | string;
  wrapperClassName?: string;
};

const DsInput = forwardRef<HTMLInputElement, DsInputPropsType>(
  (
    { className, placeholder, error, title, wrapperClassName, ...props },
    ref,
  ) => {
    const placeholderText = useTranslate(placeholder);

    const { t } = useTranslator();

    return (
      <div className={classNames("w-full max-w-md", wrapperClassName)}>
        {title && <DsText variant="button">{t(title) as string}</DsText>}
        <Input
          ref={ref}
          placeholder={placeholderText}
          className={classNames(
            "w-full rounded-md py-1.5 pl-3 pr-10 text-left text-black sm:text-md sm:leading-6 shadow-sm ring-1 bg-white ring-inset ring-gray-300 focus:outline-none",
            error ? "text-[#ba2727] bg-[#fcf4f4] ring-[#ba2727] ring-2" : "",
            className,
          )}
          {...props}
        />
        {error && (
          <DsText variant="errorText">
            {typeof error === "string"
              ? error
              : t("add_new_job_drawer.rules.invalid_input")}
          </DsText>
        )}
      </div>
    );
  },
);

DsInput.displayName = "DsInput";

export { DsInput };
